module.exports = __webpack_public_path__ + "img/ri.8fb7e843.svg";